<!-- <h2 class="font-medium" mat-dialog-title><strong>{{action}}</strong></h2> -->

<h5 class="mat-h3 fs-18">Are you Sure to delete ?</h5>

<div class="d-flex align-items-center">
  <img
    class="rounded-lg"
    alt="products"
    width="90"
    height="70"
    [src]="local_data.imagePath"
  />
  <h6 class="fw-medium mat-subheading-2 m-b-5 m-t-0 lh-sm m-l-15">
    {{ local_data.Name }}
  </h6>
</div>

<div mat-dialog-actions align="end">
  <button mat-flat-button (click)="doAction()" color="primary">
    {{action}}
  </button>
  <button mat-button color="primary" (click)="closeDialog()">Cancel</button>
</div>
